import { ApiHosts, handleResponseWithNon200Errors, makePost } from '@/redux/api/helpers';
import { ConfigSlice } from '../../config';

export type PostSendEmailVerificationCodePayload = {
    deployment: ConfigSlice['deployment'];
    email: string;
};

export type PostSendEmailVerificationCodeResponse = {
    error: boolean;
    payload: number;
};

export const postSendEmailVerificationCode = ({ deployment, email }: PostSendEmailVerificationCodePayload) =>
    new Promise<PostSendEmailVerificationCodeResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'mfa/unregistered/send-otp',
            deployment,
            path: ApiHosts.Authentication,
        });
        request.send({
            email,
        });
        request.end((err, response) =>
            handleResponseWithNon200Errors({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

export type PostSubmitEmailVerificationCodePayload = {
    deployment: ConfigSlice['deployment'];
    otp: string;
    unregisteredUserId: number;
};

export type PostSubmitEmailVerificationCodeResponse = {
    error: boolean;
    payload: number;
};

export const postSubmitEmailVerificationCode = ({
    deployment,
    otp,
    unregisteredUserId,
}: PostSubmitEmailVerificationCodePayload) =>
    new Promise<PostSubmitEmailVerificationCodeResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'mfa/unregistered/verify-otp',
            deployment,
            path: ApiHosts.Authentication,
        });
        request.query({ userId: unregisteredUserId });
        request.send({
            otp,
        });
        request.end((err, response) =>
            handleResponseWithNon200Errors({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
